<div class="backdrop" [class.visible]="loading">
    <mat-spinner></mat-spinner>
</div>

